import React from 'react'
import { debug } from '@bt-react/libs/Logger'
import { ErrorBoundaryProps, ErrorBoundaryState } from './types'

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {

  constructor (props) {

    super(props)
    this.state = { hasError: false }

  }

  componentDidCatch (error, info) {

    // Display fallback UI
    this.setState({ hasError: true })
    // You can also log the error to an error reporting service
    console.log(error)
    debug(error)

  }

  render () {

    if (this.state.hasError) {

      return null

    }
    return this.props.children

  }

}

export default ErrorBoundary
